import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconNames, NOT_AVAILABLE, S_CODE_ICONS, SCode } from '../../common/constants';

@Component({
  selector: 'ui-status-code',
  templateUrl: './status-code.component.html',
  styleUrls: ['./status-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusCodeComponent {
  @Input() statusCode: string;
  @Input() statusDescription: string;
  @Input() needEmptySpaceFoNoIconCase = true;

  sCodeIcons: Map<SCode, IconNames> = S_CODE_ICONS;
  notAvailable = NOT_AVAILABLE;
}
